import React from 'react';
import { Modal } from '../../components/ui';
import ExportButton from '../../components/ExportButton';

// "Who is coming to what" is not one list but several: the people invited to
// the Reception only, the ones invited to the Wedding AND the Reception, the
// ones who also have the Thread Ceremony. This shows every set that actually
// exists in the guest list with its size, and makes one file of the ticked
// ones - a sheet per list, so it prints as separate lists.
export default function FunctionSetsDesktop({ vm, onClose }) {
  const { functionSets, setsOff, toggleSet, setsAllOn, toggleAllSets, chosenSets, setsReport,
    adder, adderIsMe, setAdderFilter, groupFilter, stats } = vm;
  const guests = chosenSets.reduce((n, s) => n + s.guests, 0);
  const persons = chosenSets.reduce((n, s) => n + s.persons, 0);

  return (
    <Modal
      wide dense className="fnsets-modal" title="Guest lists by function" onClose={onClose}
      footer={<>
        <span className="muted" style={{ flex: 1, fontSize: 12 }}>
          {chosenSets.length} {chosenSets.length === 1 ? 'list' : 'lists'} · {guests} guests · {persons} persons
          {' — each list starts on its own page'}
        </span>
        <button className="btn light" onClick={onClose}>Close</button>
        <ExportButton report={setsReport} className="btn primary" label="⇪ Make the lists" />
      </>}
    >
      <div className="muted fnsets-note">
        A guest belongs to <strong>exactly one</strong> list: the whole set of functions they are invited to.
        “Reception only” is not everyone coming to the Reception — those people are also in the longer
        sets below it. For one list of everyone at a function, use the toolbar filter instead.
      </div>
      {/* The page's filters narrow these lists too, and that is the number one
          reason a count looks too small - so it is said, with the way out. */}
      {(adder || groupFilter) && (
        <div className="fnsets-scope">
          These lists cover <strong>{adderIsMe ? 'your own guests' : adder ? adder.label : ''}</strong>
          {adder && groupFilter ? ' · ' : ''}{groupFilter ? <>group <strong>{groupFilter}</strong></> : null}
          {' '}— {stats.parties} of the event's guests.
          {adder && (
            <button type="button" className="linklike" onClick={() => setAdderFilter('')}>
              Use everyone's guests
            </button>
          )}
        </div>
      )}

      {functionSets.length === 0 ? (
        <div className="empty">No guests to list yet.</div>
      ) : (
        <table className="tbl compact fnsets-table">
          <thead>
            <tr>
              <th style={{ width: 28 }}>
                <input type="checkbox" checked={setsAllOn} onChange={toggleAllSets} title="All lists / none" />
              </th>
              <th className="grow">Invited to</th>
              <th className="mn-r">Functions</th>
              <th className="mn-r">Guests</th>
              <th className="mn-r">Persons</th>
            </tr>
          </thead>
          <tbody>
            {functionSets.map(s => {
              const on = !setsOff.has(s.key);
              return (
                <tr key={s.key} className={on ? '' : 'brief-off'} onClick={(e) => {
                  if (e.target.tagName !== 'INPUT') toggleSet(s.key);
                }}>
                  <td><input type="checkbox" checked={on} onChange={() => toggleSet(s.key)} /></td>
                  <td><strong>{s.label}</strong></td>
                  <td className="mn-r">{s.count}</td>
                  <td className="mn-r"><strong>{s.guests}</strong></td>
                  <td className="mn-r">{s.persons}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td /><td><strong>Total</strong></td><td />
              <td className="mn-r"><strong>{guests}</strong></td>
              <td className="mn-r">{persons}</td>
            </tr>
          </tfoot>
        </table>
      )}
    </Modal>
  );
}
